<template>
  <SoDialog
    v-model="value"
    card-title="Fetch Smart Readings"
    data-testid="fetch-smart-reads-modal"
  >
    <FetchSmartReadWidgets />
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import SoDialog from "@/components/SoDialog.vue"
  import FetchSmartReadWidgets from "@/components/meterpoints/FetchSmartReadWidgets.vue"

  export default defineComponent({
    components: {
      FetchSmartReadWidgets,
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
